

export const getTokenExpiration = (params) => {
    const { timestamp, expiresIn } = params;
    if (!!timestamp && !!expiresIn) {
      return timestamp + expiresIn * 1000;
    }
    return undefined;
  };
  
  export const isTokenValid = (params) => {
    const { token, timestamp, expiresIn } = params;
    if (token && timestamp && expiresIn) {
      const currentTimestamp = Date.now();
      const expiredTime = getTokenExpiration(params);
      if (expiredTime) {
        return currentTimestamp < expiredTime;
      }
    }
    return false;
  };
  
  /**
   * This merely checks that there IS an access token, and that
   * the expiration for the token has not been exceeded. No API
   * calls are made to test the validity.
   */
  export const isAccessTokenValid = (params)=> {
    const { access_token, expires_in = 0, timestamp } = params;
    return isTokenValid({ expiresIn: expires_in, timestamp, token: access_token });
  };
  
  export const isRefreshTokenValid = (loginState) => {
    const { refresh_token, refresh_expires_in = 0, timestamp } = loginState;
    return isTokenValid({ expiresIn: refresh_expires_in, timestamp, token: refresh_token });
  };
  